import React, { ReactNode, useEffect, useState } from 'react';

interface ModalActionsContainerProps {
  /**
   * The action buttons to display in the container
   */
  children: ReactNode;

  /**
   * Optional additional CSS classes to apply to the container
   */
  className?: string;

  /**
   * Distance from bottom of modal in Tailwind spacing units (default: 4 = 16px)
   */
  bottomOffset?: number;
}

/**
 * A container for action buttons positioned at the bottom of modals.
 * Provides consistent styling and positioning for modal-specific bulk actions.
 */
export const ModalActionsContainer: React.FC<ModalActionsContainerProps> = ({
  children,
  className = '',
  bottomOffset = 4,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  // Trigger animation on mount
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100); // Small delay to ensure modal content is rendered

    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={`dark:bg-base-100 dark:shadow-gray-1000/30 absolute left-1/2 flex -translate-x-1/2 transform gap-1 rounded-lg border border-gray-400 bg-white p-1 shadow-xl shadow-gray-500/30 transition-all duration-300 ease-in-out dark:border-gray-800 ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'
      } ${className}`}
      style={{ bottom: `${bottomOffset * 0.25}rem` }}>
      {children}
    </div>
  );
};
